import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"
import { TCheckoutForm, TVendedor } from ".."
import { useContext, useEffect, useMemo } from "react"
import { AuthContext } from "../../../../../../../../contexts/AuthContext"
import PaperDraggable from "../../../../../../../../components/PaperDraggable"
import SelectVendedores from "../../../../../../../../components/SelectsSimpleApiQuery/SelectVendedores"
import SelectConsultor from "../../../../../../../../components/SelectsSimpleApiQuery/SelectConsultor"
import SelectProcuradores from "../../../../../../../../components/SelectsSimpleApiQuery/SelectProcuradores/SelectProcuradores"

export default function DialogConfirmarCriacao({
    open,
    handleClose,
    onSubmit
}: DialogConfirmarCriacaoProps) {

    const { handleSubmit, control, getValues, setValue } = useFormContext<TCheckoutForm>()
    const { getUserData } = useContext(AuthContext)

    const vendedor = getValues("vendedor")

    const vendedores = useMemo(() => {
        const lojaFaturamento = getValues('loja_faturamento')
        const perfisVendedores = getUserData()?.perfis_vinculados
            .filter((perfil: any) =>
                perfil.vendedor &&
                perfil.loja?.id === lojaFaturamento?.id
            ) || []
        return perfisVendedores.map((perfil: any) => perfil.vendedor)
    }, [getUserData, getValues])

    useEffect(() => {
        if (vendedores.length > 0 && !vendedor) {
            const vendedor = vendedores[0]
            setValue('vendedor', vendedor)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vendedores, vendedor])

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
                Confirmação
            </DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>

                            <Controller
                                control={control}
                                name="comprador"
                                rules={{ required: "Campo obrigatório" }}
                                render={({ field, fieldState: { error, invalid } }) => (
                                    <SelectProcuradores
                                        required
                                        value={getValues("comprador") || ""}
                                        onChange={(value) => setValue("comprador", value)}
                                        extraParams={{ tipo_publico: getValues("cliente").tipo_publico, codigo_publico: getValues("cliente").codigo_publico }}
                                        error={invalid}
                                        errorMessage={error?.message}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Controller
                                control={control}
                                name="vendedor"
                                rules={{ required: "Campo obrigatório" }}
                                render={({ field, fieldState: { error, invalid } }) => {
                                    if (vendedores.length > 0) return (
                                        <TextField
                                            required
                                            {...field}
                                            error={invalid}
                                            select
                                            label="Vendedor"
                                            fullWidth
                                            value={JSON.stringify(field.value ?? "")}
                                            onChange={(e) => field.onChange(JSON.parse(e.target.value))}
                                            helperText={invalid ? error?.message : ""}
                                        >
                                            {vendedores.map((vendedor: TVendedor) => (
                                                <MenuItem key={vendedor.id} value={JSON.stringify(vendedor)}>
                                                    {vendedor.nome}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )
                                    return (
                                        <SelectVendedores
                                            required
                                            error={invalid}
                                            errorMessage={error?.message}
                                            value={field.value}
                                            onChange={(value) => field.onChange(value)}
                                        />
                                    )
                                }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Controller
                                control={control}
                                name="consultor"
                                render={({ field }) =>
                                    <SelectConsultor
                                        value={field.value}
                                        onChange={(value) => field.onChange(value)}
                                        possuiBtnLimpar
                                    />
                                }
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <Controller
                                control={control}
                                name="observacao"
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Observações"
                                        multiline
                                        rows={7}
                                        fullWidth
                                        value={field.value}
                                        onChange={(e) => field.onChange(e.target.value)}
                                        slotProps={{ htmlInput: { maxLength: 380 } }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined">Cancelar</Button>
                    <Button type="submit" variant="contained">Confirmar</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

interface DialogConfirmarCriacaoProps {
    open: boolean,
    handleClose: () => void,
    onSubmit: (data: TCheckoutForm) => void
}
